import { render } from "./AddUser.vue?vue&type=template&id=2a9a283e&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import "./AddUser.vue?vue&type=style&index=0&id=2a9a283e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9a283e"]])

export default __exports__